import { Modal, Typography, Card, Tag } from "antd";
import { CloseOutlined, CalendarOutlined, ScheduleOutlined, EnvironmentOutlined, ClockCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import { formatControlInterno } from "./calendarUtils";

const { Title, Text } = Typography;

export default function DayEventsModal({
  isDayModalVisible,
  setIsDayModalVisible,
  selectedDay,
  dayEvents,
  onEventClick,
}) {
  const formatAddress = (item) => {
    const addressParts = [];
    if (item.Municipio) addressParts.push(item.Municipio);
    if (item.Estado) addressParts.push(item.Estado);

    if (addressParts.length === 0) {
      return "Sin ubicación";
    }

    return addressParts.join(", ");
  };

  return (
    <Modal
      title={null}
      visible={isDayModalVisible}
      onCancel={() => setIsDayModalVisible(false)}
      footer={null}
      width={700}
      closeIcon={<CloseOutlined style={{ fontSize: "18px" }} />}
      bodyStyle={{ padding: 0 }}
    >
      <div>
        <div
          style={{
            background: "linear-gradient(135deg, #52c41a 0%, #389e0d 100%)",
            padding: "24px 32px",
            color: "white",
          }}
        >
          <Title level={3} style={{ color: "white", margin: 0 }}>
            {selectedDay ? selectedDay.format("DD [de] MMMM, YYYY") : ""}
          </Title>
          <Text style={{ color: "rgba(255,255,255,0.85)" }}>
            {dayEvents.length} {dayEvents.length === 1 ? "evento" : "eventos"}
          </Text>
        </div>
        <div style={{ padding: "24px 32px", maxHeight: "500px", overflowY: "auto" }}>
          {dayEvents.length === 0 ? (
            <div style={{ textAlign: "center", padding: "40px 0", color: "#8c8c8c" }}>
              <CalendarOutlined style={{ fontSize: "48px", marginBottom: "16px" }} />
              <div>No hay eventos programados para este día</div>
            </div>
          ) : (
            dayEvents.map((item) => (
              <Card
                key={item.id}
                style={{
                  marginBottom: "16px",
                  cursor: "pointer",
                  border: "1px solid #d9d9d9",
                  transition: "all 0.3s ease",
                }}
                hoverable
                onClick={() => onEventClick(item.id, item.Tipo)}
                bodyStyle={{ padding: "16px" }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start" }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px" }}>
                      <ScheduleOutlined style={{ color: "#1890ff", fontSize: "16px" }} />
                      <Text strong style={{ fontSize: "16px", color: "#1890ff" }}>
                        {formatControlInterno(item.ControlInterno)}
                      </Text>
                    </div>
                    {(item.Hora1 || item.Hora2) && (
                      <div style={{ display: "flex", alignItems: "center", gap: "8px", color: "#595959" }}>
                        <ClockCircleOutlined />
                        <Text>
                          {item.Hora1 ? moment(item.Hora1, "HH:mm").format("HH:mm") : ""} -
                          {item.Hora2 ? moment(item.Hora2, "HH:mm").format("HH:mm") : ""}
                        </Text>
                      </div>
                    )}
                  </div>
                  <div>
                    <Tag color="blue">
                      <EnvironmentOutlined style={{ marginRight: "4px" }} />
                      {formatAddress(item)}
                    </Tag>
                  </div>
                </div>
              </Card>
            ))
          )}
        </div>
      </div>
    </Modal>
  );
}
